import { render } from "./detialProductDialog.vue?vue&type=template&id=6f699138&scoped=true"
import script from "./detialProductDialog.vue?vue&type=script&lang=js"
export * from "./detialProductDialog.vue?vue&type=script&lang=js"

import "./detialProductDialog.vue?vue&type=style&index=0&id=6f699138&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f699138"]])

export default __exports__